import React, { useState } from 'react';
import { CentsPalette } from '../../../utils/colors';

interface Props {
  name: string
  value: string | undefined
  isPassword?: boolean
  setValue: (value: string) => void
}

const LoginInput: React.FC<Props> = ({ name, value, isPassword = false, setValue }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const setProtectedValue = (value: string) => {
    setValue(value)
    if (value === "") setShowPassword(false)
  }
  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className="relative w-full flex">
      <input
        type={isPassword ? (showPassword ? 'text' : 'password') : 'text'}
        id={name}
        name={name}
        value={value ?? ""}
        onChange={isPassword ? (e) => setProtectedValue(e.target.value) : (e) => setValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`flex-1 h-14 px-4 text-base rounded-2xl border border-cents-black focus:ring-0 focus:outline-none placeholder-transparent`}
        required
      />
      {/*<label
        htmlFor={name}
        className={`absolute left-4 transform -translate-y-1/2 transition-all duration-200 
          ${isFocused || value ? 'text-xs -top-2 text-cents-black' : 'top-1/2 text-base text-gray-500'}`}
      >
        {name}
      </label>*/}
      {isPassword && (value !== "") &&
        <button type="button" onClick={toggleShowPassword} className='absolute right-4 top-1/2 transform -translate-y-1/2'>
          <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 7.99999C8.4 -2.00002 14 7.99999 14 7.99999C10.4 14 5.6 13.6 2 7.99999Z M6 8.00002C6 5.20003 10 5.20002 10 8.00002C10 10.8 6 10.4 6 8.00002Z" stroke={isFocused || value ? CentsPalette.cents_black : '#e5e7eb'} strokeLinejoin="round" />
            {showPassword && (
              <path d="M2 13.5L14 2.5" stroke={CentsPalette.cents_black} strokeLinecap="round" />
            )}
          </svg>
        </button>
      }
    </div>
  );
}

export default LoginInput;